var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"my-14"},[_c('div',{staticClass:"container px-11 2xl:px-3 m-auto"},[_c('div',{staticClass:"q10__article_container__title_head m-4"},[_c('article-title-tour',{attrs:{"options":{
                       tourtitle: _vm.currentPage.content.tourtitle.text,
                       titlecolor: 'text-sushi',
                       toursubtitle: _vm.currentPage.content.toursubtitle.text,
                       subtitlecolor: 'text-nandor',
                   }}})],1),_c('div',{staticClass:"container-components"},[_c('div',{staticClass:"card break-inside-avoid"},[_c('TimelineTitle',{attrs:{"options":{
                           year: _vm.currentPage.content.firstYear.text,
                           title: _vm.currentPage.content.firstTitle.text,
                           pretitle:
                               _vm.currentPage.content.firstPretitle.text,
                           content:
                               _vm.currentPage.content.firstContent.text,

                           fontSize: {
                               title: 'text-xl 2xl:text-2xl',
                               pretitle: 'text-6xl 2xl:text-6xl',
                           },
                           color: {
                               pretitle: 'text-sushi',
                               title: 'text-dodger_blue',
                           },
                       }},scopedSlots:_vm._u([{key:"bottom",fn:function(){return [_c('image-with-descriptions',{staticClass:"mt-1 mb-1",attrs:{"options":{
                                   image :  'pages/' +
                                   _vm.currentPage.slug + '/' +
                                   _vm.currentPage.images.image1.src,
                                   descriptions: [
                                       {
                                           text: _vm.currentPage.images.image1.edf,
                                           position: 'bottom-right', // top/bottom-left/right
                                           orientation: 'horizontal', // vertical, horizontal
                                       } ],
                               }}})]},proxy:true}])})],1),_c('div',{staticClass:"card break-inside-avoid"},[_c('TimelineTitle',{attrs:{"options":{
                           year: _vm.currentPage.content.secondYear.text,
                           pretitle:
                               _vm.currentPage.content.secondPretitle.text,
                           title: _vm.currentPage.content.secondTitle.text,
                           content:
                               _vm.currentPage.content.secondContent.text,

                           fontSize: {
                               pretitle: 'text-xl 2xl:text-2xl',
                               title: 'text-3xl 2xl:text-4xl',
                           },
                           color: {
                               title: 'text-sushi',
                           },
                       }},scopedSlots:_vm._u([{key:"bottom",fn:function(){return [_c('image-with-descriptions',{staticClass:"mt-1 mb-1",attrs:{"options":{
                                   image :  'pages/' +
                                   _vm.currentPage.slug + '/' +
                                   _vm.currentPage.images.image2.src,
                                   descriptions: [
                                       {
                                           text: _vm.currentPage.images.image2.text,
                                           position: 'bottom-right', // top/bottom-left/right
                                           orientation: 'horizontal', // vertical, horizontal
                                       } ],
                               }}})]},proxy:true}])})],1),_c('div',{staticClass:"card break-inside-avoid"},[_c('hotspot-richmedia',{staticClass:"-top-3 md:top-0 -right-2",attrs:{"options":{
                       icon: 'diaporama',
                       collection : _vm.getRichmediaByCollection(_vm.currentPage, 'La transformation du CIH 2017' ),
                   }}}),_c('TimelineTitle',{attrs:{"options":{
                           year: _vm.currentPage.content.thirdYear.text,
                           title: _vm.currentPage.content.thirdTitle.text,
                           pretitle:
                               _vm.currentPage.content.thirdPretitle.text,
                           content:
                               _vm.currentPage.content.thirdContent.text,

                           fontSize: {
                               pretitle: 'text-xl 2xl:text-2xl',
                               title: 'text-3xl 2xl:text-4xl',
                           },
                           color: {
                               title: 'text-sushi',
                           },
                       }},scopedSlots:_vm._u([{key:"bottom",fn:function(){return [_c('image-with-descriptions',{staticClass:"mt-1 mb-1",attrs:{"options":{
                                   image :  'pages/' +
                                   _vm.currentPage.slug + '/' +
                                   _vm.currentPage.images.image3.src,
                                   descriptions: [
                                       {
                                           text: _vm.currentPage.images.image3.edf,
                                           position: 'bottom-right', // top/bottom-left/right
                                           orientation: 'horizontal', // vertical, horizontal
                                           color: 'text-black',
                                       } ],
                                   color: 'text-nandor',
                                   fontSize: 'text-xs',
                               }}})]},proxy:true}])})],1),_c('div',{staticClass:"card break-inside-avoid"},[_c('TimelineTitle',{attrs:{"options":{
                           year: _vm.currentPage.content.fourthYear.text,
                           title: _vm.currentPage.content.fourthTitle.text,
                           pretitle:
                               _vm.currentPage.content.fourthPretitle.text,
                           content:
                               _vm.currentPage.content.fourthContent.text,

                           fontSize: {
                               pretitle: 'text-base 2xl:text-2xl',
                               title: 'text-3xl 2xl:text-4xl',
                           },
                           color: {
                               title: 'text-sushi',
                           },
                       }},scopedSlots:_vm._u([{key:"bottom",fn:function(){return [_c('image-with-descriptions',{staticClass:"mt-1 mb-1",attrs:{"options":{
                                   image :  'pages/' +
                                   _vm.currentPage.slug + '/' +
                                   _vm.currentPage.images.image4.src,
                                   descriptions: [
                                       {
                                           text: _vm.currentPage.images.image4.edf,
                                           position: 'bottom-right', // top/bottom-left/right
                                           orientation: 'horizontal', // vertical, horizontal
                                       } ],
                               }}})]},proxy:true}])})],1),_c('div',{staticClass:"card break-inside-avoid"},[_c('TimelineTitle',{attrs:{"options":{
                           year: _vm.currentPage.content.fifthYear.text,
                           pretitle:
                               _vm.currentPage.content.fifthPretitle.text,
                           title: _vm.currentPage.content.fifthTitle.text,
                           content:
                               _vm.currentPage.content.fifthContent.text,

                           fontSize: {
                               pretitle: 'text-xl 2xl:text-2xl',
                               title: 'text-3xl 2xl:text-4xl',
                           },
                           color: {
                               title: 'text-sushi',
                           },
                       }}})],1),_c('div',{staticClass:"card break-inside-avoid"},[_c('TimelineTitle',{attrs:{"options":{
                           year: _vm.currentPage.content.sixthYear.text,
                           pretitle:
                               _vm.currentPage.content.sixthPretitle.text,
                           title: _vm.currentPage.content.sixthTitle.text,
                           content:
                               _vm.currentPage.content.sixthContent.text,

                           fontSize: {
                               pretitle: 'text-xl 2xl:text-2xl',
                               title: 'text-3xl 2xl:text-4xl',
                           },
                           color: {
                               title: 'text-sushi',
                               pretitle: 'text-dodger_blue',
                           },
                       }}})],1),_c('div',{staticClass:"card break-inside-avoid"},[_c('hotspot-richmedia',{staticClass:"-top-3 md:top-0 -right-2",attrs:{"options":{
                       icon: 'diaporama',
                       collection : _vm.getRichmediaByCollection(_vm.currentPage, 'Les experts du CIH : épisodes 1 et 2' ),
                   }}}),_c('TimelineTitle',{attrs:{"options":{
                           year: _vm.currentPage.content.seventhYear.text,
                           title: _vm.currentPage.content.seventhTitle.text,
                           pretitle:
                               _vm.currentPage.content.seventhPretitle.text,
                           content:
                               _vm.currentPage.content.seventhContent.text,

                           fontSize: {
                               title: 'text-xl 2xl:text-2xl',
                               pretitle: 'text-3xl 2xl:text-4xl',
                           },
                           color: {
                               pretitle: 'text-sushi',
                               title: 'text-dodger_blue',
                           },
                       }},scopedSlots:_vm._u([{key:"bottom",fn:function(){return [_c('image-with-descriptions',{staticClass:"mt-1 mb-1",attrs:{"options":{
                                   image :  'pages/' +
                                   _vm.currentPage.slug + '/' +
                                   _vm.currentPage.images.image5.src,
                                   descriptions: [
                                       {
                                           text: _vm.currentPage.images.image5.text,
                                           position: 'bottom-right', // top/bottom-left/right
                                           orientation: 'horizontal', // vertical, horizontal
                                           fontSize: 'text-xs'
                                       },
                                       {
                                           text: _vm.currentPage.images.image5.alt,
                                           position: 'bottom-left', // top/bottom-left/right
                                           orientation: 'horizontal', // vertical, horizontal
                                       } ],
                               }}})]},proxy:true}])})],1),_c('div',{staticClass:"card break-inside-avoid"},[_c('TimelineTitle',{attrs:{"options":{
                           year: _vm.currentPage.content.eigthYear.text,
                           title: _vm.currentPage.content.eigthTitle.text,
                           pretitle:
                               _vm.currentPage.content.eigthPretitle.text,
                           content:
                               _vm.currentPage.content.eigthContent.text,

                           fontSize: {
                               pretitle: 'text-3xl 2xl:text-4xl',
                               title: 'text-xl 2xl:text-2xl',
                           },
                           color: {
                               pretitle: 'text-sushi',
                               title: 'text-dodger_blue',
                           },
                       }}})],1),_c('div',{staticClass:"card break-inside-avoid"},[_c('TimelineTitle',{attrs:{"options":{
                           year: _vm.currentPage.content.ninthYear.text,
                           title: _vm.currentPage.content.ninthTitle.text,
                           pretitle:
                               _vm.currentPage.content.ninthPretitle.text,
                           content:
                               _vm.currentPage.content.ninthContent.text,

                           fontSize: {
                               pretitle: 'text-xl 2xl:text-2xl',
                               title: 'text-3xl 2xl:text-4xl',
                           },
                           color: {
                               title: 'text-sushi',
                           },
                       }}},[_c('div',{staticClass:"w-1/2 h-auto lg:mx-auto"},[_c('image-with-descriptions',{staticClass:"mt-1 mb-1",attrs:{"options":{
                                   image :  'pages/' +
                                   _vm.currentPage.slug + '/' +
                                   _vm.currentPage.images.image7.src,
                                   descriptions: [
                                       {
                                           text: _vm.currentPage.images.image7.text,
                                           position: 'bottom-right', // top/bottom-left/right
                                           orientation: 'horizontal', // vertical, horizontal
                                       } ],
                               }}})],1)])],1),_c('div',{staticClass:"card break-inside-avoid"},[_c('TimelineTitle',{attrs:{"options":{
                           year: _vm.currentPage.content.eleventhYear.text,
                           title: _vm.currentPage.content.eleventhTitle.text,
                           pretitle:
                               _vm.currentPage.content.eleventhPretitle.text,
                           content:
                               _vm.currentPage.content.eleventhContent.text,

                           fontSize: {
                               pretitle: 'text-xl 2xl:text-2xl',
                               title: 'text-3xl 2xl:text-4xl',
                           },
                           color: {
                               title: 'text-sushi',
                           },
                       }},scopedSlots:_vm._u([{key:"bottom",fn:function(){return [_c('image-with-descriptions',{staticClass:"mt-1 mb-1",attrs:{"options":{
                                   image :  'pages/' +
                                   _vm.currentPage.slug + '/' +
                                   _vm.currentPage.images.image6.src,
                                   descriptions: [
                                       {
                                           text: _vm.currentPage.images.image6.edf,
                                           position: 'bottom-right', // top/bottom-left/right
                                           orientation: 'horizontal', // vertical, horizontal
                                       } ],
                               }}})]},proxy:true}])})],1),_c('div',{staticClass:"card break-inside-avoid"},[_c('TimelineTitle',{attrs:{"options":{
                           year: _vm.currentPage.content.tenYear.text,
                           pretitle:
                               _vm.currentPage.content.tenPretitle.text,
                           title: _vm.currentPage.content.tenTitle.text,
                           content:
                               _vm.currentPage.content.tenContent.text,

                           fontSize: {
                               pretitle: 'text-xl 2xl:text-2xl',
                               title: 'text-3xl 2xl:text-4xl',
                           },
                           color: {
                               title: 'text-sushi',
                           },
                       }},scopedSlots:_vm._u([{key:"bottom",fn:function(){return [_c('image-with-descriptions',{staticClass:"mt-1 mb-1",attrs:{"options":{
                                   image :  'pages/' +
                                   _vm.currentPage.slug + '/' +
                                   _vm.currentPage.images.image8.src,
                                   descriptions: [
                                       {
                                           text: _vm.currentPage.images.image8.text,
                                           position: 'bottom-right', // top/bottom-left/right
                                           orientation: 'horizontal', // vertical, horizontal
                                       },
                                       {
                                           text: _vm.currentPage.images.image8.alt,
                                           position: 'top-left', // top/bottom-left/right
                                           orientation: 'horizontal', // vertical, horizontal
                                       } ],
                               }}})]},proxy:true}])})],1),_c('div',{staticClass:"card break-inside-avoid"},[_c('hotspot-richmedia',{staticClass:"-top-3 md:top-0 -right-2",attrs:{"options":{
                       icon: 'diaporama',
                       collection : _vm.getRichmediaByCollection(_vm.currentPage, 'Parlons compétences' ),
                   }}}),_c('TimelineTitle',{attrs:{"options":{
                           year: _vm.currentPage.content.twelveYear.text,
                           title: _vm.currentPage.content.twelveTitle.text,
                           pretitle:
                               _vm.currentPage.content.twelvePretitle.text,
                           content:
                               _vm.currentPage.content.twelveContent.text,

                           fontSize: {
                               title: 'text-xl 2xl:text-2xl',
                               pretitle: 'text-3xl 2xl:text-4xl',
                           },
                           color: {
                               pretitle: 'text-sushi',
                               title: 'text-dodger_blue',
                           },
                       }},scopedSlots:_vm._u([{key:"bottom",fn:function(){return [_c('image-with-descriptions',{staticClass:"mt-1 mb-1",attrs:{"options":{
                                   image :  'pages/' +
                           _vm.currentPage.slug + '/' +
                           _vm.currentPage.images.image9.src,
                               }}})]},proxy:true}])})],1),_c('div',{staticClass:"card break-inside-avoid"},[_c('TimelineTitle',{attrs:{"options":{
                           year: _vm.currentPage.content.thirdteenYear.text,
                           pretitle:
                               _vm.currentPage.content.thirdteenPretitle.text,
                           title: _vm.currentPage.content.thirdteenTitle.text,
                           content:
                               _vm.currentPage.content.thirdteenContent.text,

                           fontSize: {
                               pretitle: 'text-xl 2xl:text-2xl',
                               title: 'text-3xl 2xl:text-4xl',
                           },
                           color: {
                               title: 'text-sushi',
                           },
                       }},scopedSlots:_vm._u([{key:"bottom",fn:function(){return [_c('image-with-descriptions',{staticClass:"mt-1 mb-1",attrs:{"options":{
                                   image :  'pages/' +
                                   _vm.currentPage.slug + '/' +
                                   _vm.currentPage.images.image10.src,
                                   descriptions: [
                                       {
                                           text: _vm.currentPage.images.image10.edf,
                                           position: 'bottom-right', // top/bottom-left/right
                                           orientation: 'horizontal', // vertical, horizontal
                                           color: 'text-nandor',
                                           fontSize: 'text-base',
                                       } ],

                               }}})]},proxy:true}])})],1),_c('div',{staticClass:"card break-inside-avoid"},[_c('TimelineTitle',{attrs:{"options":{
                           year: _vm.currentPage.content.fourthteenYear.text,
                                   pretitle:
                                       _vm.currentPage.content.fourthteenPretitle.text,
                                   title: _vm.currentPage.content.fourthteenTitle.text,
                                   content:
                                       _vm.currentPage.content.fourthteenContent.text,


                           fontSize: {
                               pretitle: 'text-xl 2xl:text-2xl',
                               title: 'text-3xl 2xl:text-4xl',
                           },
                           color: {
                               title: 'text-sushi',
                           },
                       }},scopedSlots:_vm._u([{key:"bottom",fn:function(){return [_c('image-with-descriptions',{staticClass:"mt-1 mb-1",attrs:{"options":{
                                   image :  'pages/' +
                                   _vm.currentPage.slug + '/' +
                                   _vm.currentPage.images.image11.src,
                                   descriptions: [
                                       {
                                           text: _vm.currentPage.images.image11.edf,
                                           position: 'bottom-right', // top/bottom-left/right
                                           orientation: 'horizontal', // vertical, horizontal
                                       } ],
                               }}})]},proxy:true}])})],1),_c('div',{staticClass:"card break-inside-avoid"},[_c('div',{staticClass:"\n                           container-timeline-title-si-image-with-description\n                           relative\n                       "},[_c('div',{staticClass:"\n                               relative\n                               top-0\n                               left-0\n                               p-7\n                               xl:p-3\n                               2xl:p-7\n                               m-4\n                               bg-sushi\n                           "},[_c('TimelineTitle',{attrs:{"options":{
                                   year: _vm.currentPage.content.fifteenYear.text,
                                   title: _vm.currentPage.content.fifteenTitle.text,
                                   pretitle:
                                       _vm.currentPage.content.fifteenPretitle.text,
                                   content:
                                   _vm.currentPage.content.fifteenContent.text,
                                   fontSize: {
                                       title: 'text-2xl',
                                       year: 'text-xl',
                                   },
                                   color: {
                                       year: 'text-selective_orange',
                                       pretitle: 'text-white ',
                                       title: 'text-white',
                                       content: 'text-white',
                                   },
                               }}})],1)])]),_c('div',{staticClass:"card break-inside-avoid"},[_c('TimelineTitle',{attrs:{"options":{
                           year: _vm.currentPage.content.sixteenYear.text,
                           title: _vm.currentPage.content.sixteenTitle.text,
                           pretitle:
                               _vm.currentPage.content.sixteenPretitle.text,
                           content:
                               _vm.currentPage.content.sixteenContent.text,

                           fontSize: {
                               pretitle: 'text-xl 2xl:text-2xl',
                               title: 'text-2xl lg:text-3xl 2xl:text-4xl',
                           },
                           color: {
                               title: 'text-sushi',
                           },
                       }}},[_c('div',{staticClass:"relative pt-6"},[_c('hotspot-richmedia',{staticClass:"top-3 right-2",attrs:{"options":{
                                   icon: 'diaporama',
                                   collection : _vm.getRichmediaByCollection(_vm.currentPage, 'Hydrorenewables, le magazine externe du CIH' ),
                               }}})],1),_c('image-with-descriptions',{staticClass:"mt-1 mb-1",attrs:{"options":{
                                   image :  'pages/' +
                                   _vm.currentPage.slug + '/' +
                                   _vm.currentPage.images.image12.src,
                                   descriptions: [
                                       {
                                           text: '',
                                           position: 'bottom-right', // top/bottom-left/right
                                           orientation: 'horizontal', // vertical, horizontal
                                       } ],
                               }}})],1)],1),_c('div',{staticClass:"card break-inside-avoid"},[_c('TimelineTitle',{attrs:{"options":{
                           year: _vm.currentPage.content.seventeenYear.text,
                           title: _vm.currentPage.content.seventeenTitle.text,
                           pretitle:
                               _vm.currentPage.content.seventeenPretitle.text,
                           content:
                               _vm.currentPage.content.seventeenContent.text,

                           fontSize: {
                               pretitle: 'text-sm 2xl:text-lg',
                               title: 'text-3xl 2xl:text-4xl',
                           },
                           color: {
                               title: 'text-sushi',
                           },
                       }},scopedSlots:_vm._u([{key:"bottom",fn:function(){return [_c('image-with-descriptions',{staticClass:"mt-1 mb-1",attrs:{"options":{
                                   image :  'pages/' +
                                   _vm.currentPage.slug + '/' +
                                   _vm.currentPage.images.image13.src,
                                   descriptions: [
                                       {
                                           text: _vm.currentPage.images.image13.text,
                                           position: 'bottom-right', // top/bottom-left/right
                                           orientation: 'horizontal', // vertical, horizontal
                                       },
                                       {
                                           text: _vm.currentPage.images.image13.alt,
                                           position: 'top-left', // top/bottom-left/right
                                           orientation: 'horizontal', // vertical, horizontal
                                       } ],
                               }}})]},proxy:true}])})],1),_c('div',{staticClass:"card break-inside-avoid"},[_c('TimelineTitle',{attrs:{"options":{
                           year: _vm.currentPage.content.eigteenYear.text,
                           title: _vm.currentPage.content.eigteenTitle.text,
                           pretitle:
                               _vm.currentPage.content.eigteenPretitle.text,
                           content:
                               _vm.currentPage.content.eigteenContent.text,

                           fontSize: {
                               title: 'text-xl 2xl:text-2xl',
                               pretitle: 'text-3xl 2xl:text-4xl',
                           },
                           color: {
                               pretitle: 'text-sushi',
                               title: 'text-dodger_blue',
                           },
                       }},scopedSlots:_vm._u([{key:"bottom",fn:function(){return [_c('image-with-descriptions',{staticClass:"mt-1 mb-1",attrs:{"options":{
                                   image :  'pages/' +
                                   _vm.currentPage.slug + '/' +
                                   _vm.currentPage.images.image14.src,
                               }}})]},proxy:true}])})],1)])]),_c('timeline-carousel',{attrs:{"options":{
           timeline: _vm.currentPage.timeline
       }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }